import React from "react";
import { Text, Flex, Circle } from "@chakra-ui/react";

type DiagramKeyProps = {
  color: string;
  label: string;
  value: string;
};

export function DiagramKey({ color, label, value }: DiagramKeyProps) {
  return (
    <Flex align="center" color="brand.textSecondary.light" gap="smallest">
      <Circle bg={color} size="10px" />
      <Text textStyle={{ base: "caption2", lg: "caption1" }}>
        {label}{" "}
        <Text as="span" fontWeight="semibold">
          {value}
        </Text>
      </Text>
    </Flex>
  );
}
